import { AreaStatus, AreaType } from '@/interfaces/area'
import {
  OrderOrigin,
  OrderPaymentStatus,
  OrderReceiptStatus,
} from '@/interfaces/billing'

// Map OrderReceiptStatus to Spanish labels
export const ORDER_STATUS_LABELS: Record<OrderReceiptStatus, string> = {
  CREATED: 'Creada',
  IN_PROCESS: 'En proceso',
  PROCESSED: 'Procesada',
  COMPLETED: 'Completada',
  CANCELLED: 'Cancelada',
  DELIVERY_ASSIGNED: 'Asignada a mensajero',
  ACCEPTED: 'Aceptada por mensajero',
  IN_TRANSIT: 'En tránsito',
  DELIVERED: 'Entregada',
  REFUNDED: 'Reembolsada',
}

// Map AREA_TYPE_LABELS to Spanish labels
export const AREA_TYPE_LABELS: Record<AreaType, string> = {
  SALE: 'Punto de Venta',
  STOCK: 'En Almacén',
  MANUFACTURER: 'Área de procesado',
  ACCESSPOINT: 'Punto de acceso',
}

// Map AREA_STATUS_LABELS to Spanish labels
export const AREA_STATUS_LABELS: Record<AreaStatus, string> = {
  TRUE: 'Activa',
  FALSE: 'Inactiva',
}

// Map OrderPaymentStatus to Spanish labels
export const PAYMENT_STATUS_LABELS: Record<OrderPaymentStatus, string> = {
  PAYMENT_PENDING: 'Pendiente de pago',
  BILLED: 'Pagada',
  REFUNDED: 'Reembolsada',
  PARTIALLY_REFUNDED: 'Parcialmente reembolsada',
  CANCELLED: 'Cancelada',
  PARTIALLY_PAID: 'Parcialmente pagada',
}

export const ORDER_ORIGIN_LABELS: Record<
  Extract<
    OrderOrigin,
    | 'Tecopos-Marketplace'
    | 'Tecopos-MarketplaceApk'
    | 'External-Thirdparty'
    | 'Tecopos'
    | 'Tecopos-Admin'
    | 'Tecopos-Shop'
    | 'Tecopos-ShopApk'
  >,
  string
> = {
  'Tecopos-Marketplace': 'Sin Terceros',
  'Tecopos-MarketplaceApk': 'APK Sin Terceros',
  'External-Thirdparty': 'Externo',
  Tecopos: 'Punto de venta',
  'Tecopos-Admin': 'Administración',
  'Tecopos-Shop': 'Tienda online',
  'Tecopos-ShopApk': 'APK Tienda',
}
// Generate status options for order status
export const orderStatusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(ORDER_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate type options for area
export const areaTypeOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(AREA_TYPE_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate status options for area
export const areaStatusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(AREA_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate status options for payment status
export const paymentStatusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(PAYMENT_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate status options for order origin
export const orderOriginOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(ORDER_ORIGIN_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Type for status option
export interface StatusOption {
  value: string
  label: string
}
